const getCharger = (chargers, type) => {
  return chargers.filter((charger) => charger.type === type)[0];
};

export default getCharger;
